import { motion, useReducedMotion, type HTMLMotionProps } from 'framer-motion';

const EASE_STANDARD: [number, number, number, number] = [0.2, 0, 0.2, 1];

interface RevealProps extends HTMLMotionProps<'div'> {
  /** Stagger index — reveal is delayed by index * 110ms (capped at 6 steps). */
  index?: number;
  /** Distance in px the element travels while fading in. */
  y?: number;
}

export function Reveal({ index = 0, y = 24, transition, ...props }: RevealProps) {
  const reducedMotion = useReducedMotion();

  return (
    <motion.div
      initial={reducedMotion ? false : { opacity: 0, y }}
      whileInView={reducedMotion ? undefined : { opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.1, margin: '0px 0px -10% 0px' }}
      transition={{
        duration: 0.7,
        delay: Math.min(index, 6) * 0.11,
        ease: EASE_STANDARD,
        ...transition,
      }}
      {...props}
    />
  );
}
